module.exports = __webpack_public_path__ + "static/adesida-6df6b7d859a086c44429d118a73732e0.png";